/** 针对医院特殊逻辑，尽量在这个配置里解决 */

export const HOSPITAL_CONFIG = {
  default: {
    patientRegisterName: '院内登记号',
    projectName: '全周期智能管理平台',
    miniProjectName: '健康智管理',
  },
  20003: {
    patientRegisterName: '病历号',
  },
};

type ValueKey = keyof typeof HOSPITAL_CONFIG.default;

export const getHospitalValue = (hospitalId: number, key: ValueKey) => {
  const defaultValue = HOSPITAL_CONFIG.default[key];
  const targetValue = HOSPITAL_CONFIG[hospitalId]?.[key];
  return targetValue === undefined ? defaultValue : targetValue;
};
